import {defineMessages} from 'react-intl';

const messages = defineMessages({
  clickToSign: {
    id: 'clickToSign',
    defaultMessage: 'Click to sign'
  },
  signature: {
    id: 'signature',
    defaultMessage: 'Signature'
  },
  clear: {
    id: 'clear',
    defaultMessage: 'Clear'
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel'
  },
  acceptAndSign: {
    id: 'acceptAndSign',
    defaultMessage: 'Accept and sign'
  }
});
export default messages;
